import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgNavIconAutomation = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 27.5 20",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		d: "M22,0H17.6l5.5,10L17.6,20H22l5.5-10ZM13.2,0H8.8l5.5,10L8.8,20h4.4l5.5-10ZM4.4,0H0L5.5,10,0,20H4.4L9.9,10Z"
	})
});
export default SvgNavIconAutomation;
